// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-progress-indicator {
    font-weight: bold;
    text-align: center;
    padding: 20px;
}

.survey-progress-indicator .progress-bar {
    width: 150px;
    position: absolute;
    left: calc(50% - 75px);
    top: 24px;
}

.survey-progress-indicator .progress-bar .progress-bar-background {
    height: 8px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    width: 100%;
    background: var(--survey-progress-track-color);
    overflow: hidden;
}

.survey-progress-indicator .progress-bar .progress-bar-bar {
    height: 8px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0px;
    background-color: var(--survey-accent-fill-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyProgressIndicator/SurveyProgressIndicator.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iDAAiD;AACrD","sourcesContent":[".survey-progress-indicator {\n    font-weight: bold;\n    text-align: center;\n    padding: 20px;\n}\n\n.survey-progress-indicator .progress-bar {\n    width: 150px;\n    position: absolute;\n    left: calc(50% - 75px);\n    top: 24px;\n}\n\n.survey-progress-indicator .progress-bar .progress-bar-background {\n    height: 8px;\n    border-radius: 4px;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    background: var(--survey-progress-track-color);\n    overflow: hidden;\n}\n\n.survey-progress-indicator .progress-bar .progress-bar-bar {\n    height: 8px;\n    border-radius: 4px;\n    position: absolute;\n    left: 0;\n    top: 0px;\n    background-color: var(--survey-accent-fill-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
